import { render } from "./EjwBrand.vue?vue&type=template&id=afb00f30&scoped=true"
import script from "./EjwBrand.vue?vue&type=script&lang=js"
export * from "./EjwBrand.vue?vue&type=script&lang=js"

import "./EjwBrand.vue?vue&type=style&index=0&id=afb00f30&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb00f30"]])

export default __exports__